// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellFilledSvg from "@ant-design/icons-svg/es/asn/BellFilled";
import AntdIcon from '../components/AntdIcon';

var BellFilled = function BellFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellFilledSvg
  }));
};

BellFilled.displayName = 'BellFilled';
export default React.forwardRef(BellFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BellFilled.js
// module id = 637
// module chunks = 0